var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPaletteLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0953 24.0095C39.0953 26.6295 36.9653 28.7595 34.3353 28.7595H23.6753C22.2553 28.7595 21.1053 29.9095 21.1053 31.3295C21.1053 32.0395 21.4053 32.6795 21.8553 33.1595C22.5553 33.8895 24.4053 34.8395 23.5953 36.8695C23.0353 38.2595 21.3353 39.0195 18.7653 38.0395C12.9053 35.8195 8.79529 30.0195 9.10529 23.3095C9.45529 15.6695 15.7453 9.38952 23.3853 9.02952C31.9853 8.63952 39.0953 15.4995 39.0953 24.0195V24.0095Z",
    stroke: "#121619",
    strokeWidth: 2.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0837 20.7497C30.2937 21.5397 30.2937 22.8197 31.0837 23.6097C31.8737 24.3997 33.1537 24.3997 33.9437 23.6097C34.7337 22.8197 34.7337 21.5397 33.9437 20.7497C33.1537 19.9597 31.8737 19.9597 31.0837 20.7497Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9047 20.7497C17.6947 21.5397 17.6947 22.8197 16.9047 23.6097C16.1147 24.3997 14.8346 24.3997 14.0446 23.6097C13.2546 22.8197 13.2546 21.5397 14.0446 20.7497C14.8346 19.9597 16.1147 19.9597 16.9047 20.7497Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9952 15.7895C25.9452 16.9095 26.8052 17.8495 27.9252 17.8995C29.0452 17.9495 29.9852 17.0895 30.0352 15.9695C30.0852 14.8495 29.2252 13.9095 28.1052 13.8595C26.9852 13.8095 26.0452 14.6695 25.9952 15.7895Z",
    fill: "#121619"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9942 15.7895C22.0442 16.9095 21.1842 17.8495 20.0642 17.8995C18.9442 17.9495 18.0042 17.0895 17.9542 15.9695C17.9042 14.8495 18.7642 13.9095 19.8842 13.8595C21.0042 13.8095 21.9442 14.6695 21.9942 15.7895Z",
    fill: "#121619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaletteLight);
export default __webpack_public_path__ + "static/media/icon_palette_light.abc45287.svg";
export { ForwardRef as ReactComponent };